import React from "react";

// Redux
import {useSelector, useDispatch} from "react-redux";
import {createAddon} from "../../redux/features/addons/addonsSlice";

// Routing
import {useHistory} from "react-router-dom";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "../UI/MainPaper";
import AddonForm from "./AddonForm";
import Breadcrumbs from "../Navigation/Breadcrumbs";

const AddonsNew = () => {
  // Redux
  const dispatch = useDispatch();
  const {isLoading} = useSelector(state => state.addons);

  // Routing
  const history = useHistory();

  const breadcrumbNameMap = {
    "/addons": "Addons",
    "/addons/new": "New Addon",
  };

  const onCancel = () => {
    history.push("/addons");
  };
  const onSubmit = async values => {
    const addonObj = {
      id: null,
      ...values,
    };

    const res = await dispatch(createAddon(addonObj));
    // If addon was created successfully redirect to addons page and show user
    if (!res.error) {
      history.push({
        pathname: "/addons",
        state: {
          showSuccess: true,
          snackbarContent: `Your Addon '${addonObj.name}' was successfully created!`,
          snackbarLink: `/addons/${res.id}`,
        },
      });
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <Typography component="h1" variant="h5" gutterBottom>
            New Addon
          </Typography>
          <AddonForm
            onSubmit={onSubmit}
            onCancel={onCancel}
            isLoading={isLoading}
            submitButtonLabel="Create Addon"
          />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default AddonsNew;
